var React = require('react');

function MenuArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.833 9.26147L10.1663 5.59481","stroke":"#FD6500","strokeWidth":"1.3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13.833 9.26156L10.1663 12.9282","stroke":"#FD6500","strokeWidth":"1.3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M4.66667 9.26147L13.375 9.26147","stroke":"#FD6500","strokeWidth":"1.3","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M9.25 1.01148C4.69365 1.01148 0.999998 4.70513 0.999998 9.26148C0.999998 13.8178 4.69365 17.5115 9.25 17.5115C13.8063 17.5115 17.5 13.8178 17.5 9.26148C17.5 4.70513 13.8063 1.01148 9.25 1.01148Z","stroke":"#FD6500","strokeWidth":"1.3","strokeLinecap":"round","key":3})]);
}

MenuArrow.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = MenuArrow;

MenuArrow.default = MenuArrow;
